import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import api from './api/axios';

let firebaseAppPromise = null;

const loadFirebaseConfig = async () => {
  const response = await api.get('/api/auth/firebase-config');
  return response.data;
};

const getFirebaseAuth = async () => {
  if (!firebaseAppPromise) {
    firebaseAppPromise = loadFirebaseConfig().then((config) => {
      if (!getApps().length) {
        initializeApp(config);
      }
      return getAuth();
    });
  }

  return firebaseAppPromise;
};

export const signInWithGoogle = async () => {
  const auth = await getFirebaseAuth();
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  const idToken = await result.user.getIdToken();
  return { idToken, user: result.user };
};

export const signOutFirebase = async () => {
  try {
    const auth = await getFirebaseAuth();
    await signOut(auth);
  } catch (error) {
    // Ignore sign out errors to avoid blocking local logout
  }
};
